import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLoader from '../../Components/CommonLoader/CommonLoader';
import { watchPanelSession } from '../../Utils/panelAdminSession';

const DENIED_FLAG = 'panel_access_denied';

const AdminSessionGate = ({ children }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    return watchPanelSession((state) => {
      if (state.status === 'denied' && typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem(DENIED_FLAG, '1');
      }
      setStatus(state.status);
    });
  }, []);

  useEffect(() => {
    if (status === 'signed-out' || status === 'denied') {
      navigate('/login', { replace: true });
    }
  }, [status, navigate]);

  if (status !== 'ok') {
    return <CommonLoader />;
  }

  return children;
};

export default AdminSessionGate;
